import { AlignmentEnum, BackgroundColorEnum } from '@boels/models';
import { of } from 'rxjs';

export const imageTextMockData = {
  data$: of({
    title: 'Waar kunt u terecht?',
    bodyText:
      'Boels heeft gespecialiseerde vestigingen en specialisten op het gebied van pompen en pompinstallaties. Geïnteresseerd in de mogelijkheden? Kijk ook eens op de website van Eekels Pompen.',
    image: {
      code: 'veilig-werken-heftruck-1.jpeg',
      mime: 'image/jpeg',
      altText: 'Veilig werken met de heftruck',
      url: '/medias/veilig-werken-heftruck-1.jpeg?context=bWFzdGVyfHJvb3R8NzMyNTZ8aW1hZ2UvanBlZ3xoNzQvaGNmLzg4NDcwMTQ5NTI5OTAvdmVpbGlnLXdlcmtlbi1oZWZ0cnVjay0xLmpwZWd8YzljYjI2YWJlNmUwMzliZDVhMmI3OWEyMjFhZDIxYTRmNGEwMjBkYzc3NjM0ZTU3Y2ZlYTVlYjIyMTQ2YmZlNw',
    },
    link: {
      url: '#',
      linkName: 'Naar de website van Eekels Pompen',
    },
    imageAlignment: AlignmentEnum.LEFT,
    backgroundColor: BackgroundColorEnum.WHITE,
    removeBottomSpacing: false,
  }),
};

export const imageTextMockDataLeft = {
  data$: of({
    title: 'Waar kunt u terecht?',
    bodyText:
      'Boels heeft gespecialiseerde vestigingen en specialisten op het gebied van pompen en pompinstallaties. Geïnteresseerd in de mogelijkheden? Kijk ook eens op de website van Eekels Pompen.',
    image: {
      code: 'veilig-werken-heftruck-1.jpeg',
      mime: 'image/jpeg',
      altText: 'Veilig werken met de heftruck',
      url: '/medias/veilig-werken-heftruck-1.jpeg?context=bWFzdGVyfHJvb3R8NzMyNTZ8aW1hZ2UvanBlZ3xoNzQvaGNmLzg4NDcwMTQ5NTI5OTAvdmVpbGlnLXdlcmtlbi1oZWZ0cnVjay0xLmpwZWd8YzljYjI2YWJlNmUwMzliZDVhMmI3OWEyMjFhZDIxYTRmNGEwMjBkYzc3NjM0ZTU3Y2ZlYTVlYjIyMTQ2YmZlNw',
    },
    link: {
      url: '#',
      linkName: 'Naar de website van Eekels Pompen',
    },
    imageAlignment: AlignmentEnum.LEFT,
    backgroundColor: BackgroundColorEnum.WHITE,
    removeBottomSpacing: false,
  }),
};

export const imageTextMockDataRight = {
  data$: of({
    title: 'Waar kunt u terecht?',
    bodyText:
      'Boels heeft gespecialiseerde vestigingen en specialisten op het gebied van pompen en pompinstallaties. Geïnteresseerd in de mogelijkheden? Kijk ook eens op de website van Eekels Pompen.',
    image: {
      code: 'veilig-werken-heftruck-1.jpeg',
      mime: 'image/jpeg',
      altText: 'Veilig werken met de heftruck',
      url: '/medias/veilig-werken-heftruck-1.jpeg?context=bWFzdGVyfHJvb3R8NzMyNTZ8aW1hZ2UvanBlZ3xoNzQvaGNmLzg4NDcwMTQ5NTI5OTAvdmVpbGlnLXdlcmtlbi1oZWZ0cnVjay0xLmpwZWd8YzljYjI2YWJlNmUwMzliZDVhMmI3OWEyMjFhZDIxYTRmNGEwMjBkYzc3NjM0ZTU3Y2ZlYTVlYjIyMTQ2YmZlNw',
    },
    link: {
      url: '#',
      linkName: 'Naar de website van Eekels Pompen',
    },
    imageAlignment: AlignmentEnum.RIGHT,
    backgroundColor: BackgroundColorEnum.GREY,
    removeBottomSpacing: false,
  }),
};
